import DevSettings from 'components/admin/pages/DevSettings/DevSettings';
import FeatureFlags from 'components/admin/pages/DevSettings/components/FeatureFlags/FeatureFlags';

const ADMIN_DEV_SETTINGS = [
  {
    path: 'dev-settings',
    element: <DevSettings />,
    children: [
      {
        path: 'feature-flags',
        element: <FeatureFlags />
      }
    ]
  }
];
export default ADMIN_DEV_SETTINGS;
